import styled from 'styled-components';

const MainButton = styled.button.withConfig({
  shouldForwardProp: (prop) => prop !== 'variant' && prop !== 'size',
})`
  padding: ${({ size = 'medium', theme }) => (size === 'small' ? '0.5rem 1rem' : theme.spacing.medium || '0.75rem 1.5rem')};
  border: 1px solid transparent;
  border-radius: 8px;
  background-color: ${({ variant = 'primary', theme }) =>
    variant === 'secondary' ? theme.colors.grey || '#f3f4f6' :
      variant === 'danger' ? theme.colors.dangerBg || '#fee2e2' :
        theme.colors.brand || 'rgba(130, 22, 146, 1)'};
  color: ${({ variant = 'primary', theme }) => (
    variant === 'secondary' ? theme.colors.navText || '#374151' :
      variant === 'danger' ? theme.colors.danger || '#991b1b' :
        '#fff'
  )};
  font-size: ${({ size = 'medium', theme }) => (size === 'small' ? '0.875rem' : '1rem')};
  font-weight: 600;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);

  &:hover {
    background-color: ${({ disabled, variant = 'primary', theme }) =>
    disabled ? theme.colors.grey || '#ccc' :
      variant === 'secondary' ? theme.colors.surfaceMuted || '#e5e7eb' :
        variant === 'danger' ? theme.colors.dangerBg || '#fecaca' :
          theme.colors.brandLight || 'rgba(130, 22, 146, 0.9)'};
    transform: ${({ disabled }) => (disabled ? 'none' : 'translateY(-1px)')};
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px ${({ variant = 'primary', theme }) =>
      variant === 'danger'
        ? 'rgba(220, 53, 69, 0.2)'
        : 'var(--color-primary-bg)'};
  }

  &:active {
    transform: translateY(0);
  }
`;

export default MainButton;
